export const ENVIRONMENTS = {
  TKPROD: 'tkprod',
  TKSTAGE: 'tkstage',
  PROD: 'prod',
  STAGE: 'stage',
  DEV: 'dev'
} as const;

export const ACTIONS = {
  CREATE: 'create',
  DELETE: 'delete',
  EDIT: 'edit',
  CLONE: 'clone',
  REFRESH: 'refresh',
  VIEW: 'view',
  STATS: 'stats',
  START: 'start',
  STOP: 'stop',
  FAILED_INSIGHTS: 'failed_insights',
  FAVORITE: 'favorite',
  ACTIVATE: 'activate',
  DEACTIVATE: 'deactivate'
} as const;

export const DRB_ID_TYPE = {
  FILE: 'file',
  LINK: 'link',
  VIDEO: 'video',
  STRING: 'string',
  IMAGE: 'image'
} as const;

export const PREFIX = {
  MKT: 'mkt_',
  MKT_T: 'mkt_t_'
} as const;

export const BUNDLE_NAMES = {
  MARKETING: 'marketing',
  MARKETING_TRANSLATIONS: 'marketing_translations'
} as const;

export const UNICODE = {
  NULL: '\u0000',
  MAX_CHAR: '\uFFFF'
} as const;

export const MODE = {
  CREATE: 'create',
  EDIT: 'edit',
  VIEW: 'view'
};

export const STATUSES = {
  SUCCESS: 'SUCCEEDED',
  FAIL: 'FAILED',
  INACTIVE: 'INACTIVE',
  ACTIVE: 'ACTIVE',
  RUNNING: 'RUNNING',
  DRAFT: 'DRAFT',
  LC_ACTIVE: 'active'
} as const;

export const NOTIFICATION_ICONS = {
  SPECIAL_OFFER: 'notification_center_icon_special_offer',
  NEW_PRODUCT: 'notification_center_icon_new_product',
  TIPS_NORMAL: 'notification_center_icon_tips_normal',
  MAPS_DMC: 'notification_icon_maps_dmc',
  TIPS: 'notification_center_icon_tips',
  MAINTENANCE: 'notification_center_icon_maintenance',
  FEEDBACK: 'notification_center_icon_feedback',
  BEYOND_CLEANING: 'notification_center_beyond_cleaning'
} as const;

export const CONFIG_REGEX = '^[a-zA-Z0-9][a-z\\d\\-_:\\s]*$' as const;
export const DPI_REGEX = /^drawable[-_](mdpi|hdpi|xhdpi|xxhdpi|xxxhdpi)$/i;

export const DPI_TYPES = [
  'drawable-mdpi',
  'drawable-hdpi',
  'drawable-xhdpi',
  'drawable-xxhdpi',
  'drawable-xxxhdpi'
] as const;

export const PAYLOAD_TYPES = {
  CONTEXTUAL_MSG: 'contextual_message',
  MSG_CENTER: 'message_center',
  PERSONALIZED_OFFER: 'personalized_offer',
  BANNER: 'banner',
  TEMPLATE: 'template_view',
  HALF_MODAL: 'half_modal_view',
  FULL_MODAL: 'full_modal_view',
  PERSONALIZED_TEMPLATE: 'personalized_template_view'
} as const;

export const TIMESTAMP = 'timestampToDate' as const;

// Wizard Modal Constants:

export const ACTIVE_PARENT_URI_ID = [
  { label: 'App Home', value: 'appHome' },
  { label: 'Side Menu', value: 'side-menu' },
  { label: 'Map list', value: 'mapList' },
  { label: 'Favorite list', value: 'favoriteList' },
  { label: 'Schedule list', value: 'scheduleList' },
  { label: 'History list', value: 'historyList' },
  { label: 'Message center list', value: 'messageCenterList' },
  { label: 'Robot Health', value: 'robotHealth' },
  { label: 'Settings', value: 'settings' },
  { label: 'About robot', value: 'aboutRobot' },
  { label: 'About dock', value: 'aboutDock' },
  { label: 'Clean preferences', value: 'cleanPreferences' },
  { label: 'Atlantis clean preferences', value: 'atlantisCleanPreferences' },
  { label: 'Power boost/carpet boost', value: 'powerBoost' },
  { label: 'Clean passes', value: 'cleanPasses' },
  { label: 'Bin full behavior', value: 'binFullBehavior' },
  { label: 'Gentle mode', value: 'gentleMode' },
  { label: 'Wifi settings', value: 'wifiSettings' },
  { label: 'Robot language', value: 'robotLanguage' },
  { label: 'Map privacy', value: 'mapPrivacy' },
  { label: 'Factory reset', value: 'factoryReset' },
  { label: 'Help', value: 'help' },
  { label: 'Care maintenance', value: 'careMaintenance' },
  { label: 'FAQ Common Question', value: 'faqCommonQuestion' },
  { label: 'FAQ Get Started', value: 'faqGetStarted' },
  { label: 'FAQ Prepare Home', value: 'faqPrepareHome' },
  { label: 'FAQ Voice Assistants', value: 'faqVoiceAssistants' },
  { label: 'FAQ Errors', value: 'faqErrors' },
  { label: 'FAQ Care Maintenance', value: 'faqCareMaintenance' },
  { label: 'FAQ How Roombas Work', value: 'faqHowRoombaWork' },
  { label: 'Documents', value: 'documents' },
  { label: 'Contact iRobot', value: 'contactIRobot' },
  { label: 'Report problem', value: 'reportProblem' },
  { label: 'Smart home', value: 'smartHome' },
  { label: 'Connected services', value: 'connectedServices' },
  { label: 'IFTTT setup', value: 'IFTTTSetup' },
  { label: 'Partner setup', value: 'partnerSetup' },
  { label: 'Automations', value: 'automations' },
  { label: 'Account', value: 'account' },
  { label: 'Manage account', value: 'manageAccount' },
  { label: 'Update profile', value: 'updateProfile' },
  { label: 'Update password', value: 'updatePassword' },
  { label: 'Notifications', value: 'notifications' },
  { label: 'Privacy', value: 'privacy' },
  { label: 'Connected mobile devices', value: 'connectedMobileDevices' },
  { label: 'Add robot', value: 'addRobot' },
  { label: 'Select model', value: 'selectModel' },
  { label: 'Do not disturb', value: 'doNotDisturb' },
  { label: 'iRobot store', value: 'irobotStore' },
  { label: 'iRobot Beta', value: 'irobotBeta' }
];

export const PRIME_MIN_APP_VERSIONS = ['0.0.0', '2.2.0'];

export const PRIME_URIS = [
  { label: 'Space Overview', value: 'spaceOverview' },
  { label: 'Space Details', value: 'spaceDetails' },
  { label: 'Product Overview', value: 'productOverview' },
  { label: 'Product Details', value: 'productDetails' },
  { label: 'Create Map', value: 'createMap' },
  { label: 'Automation List', value: 'automationList' },
  { label: 'Mission History Summary', value: 'missionHistorySummary' },
  { label: 'Mission History Details', value: 'missionHistoryDetails' },
  { label: 'Map Edit', value: 'mapEdit' },
  { label: 'My Home', value: 'myHome' },
  { label: 'Store', value: 'store' },
  { label: 'Support', value: 'support' }
];

export const CATEGORY_TITLES = [
  {
    category: NOTIFICATION_ICONS.SPECIAL_OFFER,
    id: 'just_for_you_category_title_id_dmc',
    text: 'Just for you'
  },
  {
    category: NOTIFICATION_ICONS.NEW_PRODUCT,
    id: 'iseries_upsell_category_title_id_dmc',
    text: 'New Product'
  },
  { category: NOTIFICATION_ICONS.TIPS_NORMAL, id: 'tips_dmc', text: 'Tips' },
  { category: NOTIFICATION_ICONS.MAPS_DMC, id: 'map_suggestion_dmc', text: 'Map Suggestion' },
  { category: NOTIFICATION_ICONS.MAPS_DMC, id: 'map_update_dmc', text: 'Map Update' },
  { category: NOTIFICATION_ICONS.TIPS, id: 'tips_dmc', text: 'Tips' },
  { category: NOTIFICATION_ICONS.MAINTENANCE, id: 'to_dos_dmc', text: 'Maintenance' },
  { category: NOTIFICATION_ICONS.FEEDBACK, id: 'feedback_dmc', text: 'Feedback' },
  { category: 'all', id: 'special_offer_category_title_id_dmc', text: 'Special Offers' }
];

export const CATEGORY_ICON_ID = [
  NOTIFICATION_ICONS.SPECIAL_OFFER,
  NOTIFICATION_ICONS.NEW_PRODUCT,
  NOTIFICATION_ICONS.TIPS_NORMAL,
  NOTIFICATION_ICONS.MAPS_DMC,
  NOTIFICATION_ICONS.TIPS,
  NOTIFICATION_ICONS.MAINTENANCE,
  NOTIFICATION_ICONS.FEEDBACK,
  NOTIFICATION_ICONS.BEYOND_CLEANING
];

export const MESSAGE_TYPE = [
  PAYLOAD_TYPES.MSG_CENTER,
  PAYLOAD_TYPES.CONTEXTUAL_MSG,
  PAYLOAD_TYPES.BANNER,
  PAYLOAD_TYPES.PERSONALIZED_OFFER
] as const;
export const ACTION_TYPE = ['content', 'suggested_schedule', 'scripted_navigation', 'webview'] as const;
export const DISPLAY_TYPE = ['inline', 'separate_view', 'modal_view'] as const;

export const PUSH_NOTIFCATION_TYPES = [
  'push_dock_update_alert',
  'push_important_generic',
  'push_product_announcement',
  'push_mission_survey',
  'push_dynamic',
  'map_dirty'
] as const;

export const METADATA_TYPES = [
  { value: 'mca', name: 'Message Center Alert PN' },
  { value: 'mkt_mca', name: 'Marketing Message Center Alert PN' },
  { value: 'mca_pn_hd', name: 'Product Health Message Center Alert PN' }
] as const;

export const CAMPAIGN_TYPES = [
  { value: 'Notification', name: 'Notification' },
  { value: 'DataCollection', name: 'Data Collection' },
  { value: 'BetaSurvey', name: 'Beta Survey' },
  { value: 'SpaceChanged', name: 'Space Changed' },
  { value: 'ObjectZoneRecommendation', name: 'Object Zone Recommendation' },
  {
    value: 'SmartScheduleRecommendation',
    name: 'Smart Schedule Recommendation'
  },
  { value: 'MissionSurvey', name: 'Mission Survey' },
  { value: 'eCommerce', name: 'eCommerce' },
  { value: 'MapRecommendation', name: 'Map Recommendation' },
  {
    value: 'HighTrafficZoneRecommendation',
    name: 'High Traffic Zone Recommendation'
  },
  { value: 'Notification2', name: 'Notification2' },
  { value: 'FavoriteRecommendation', name: 'Favorite Recommendation' },
  { value: 'ExperimentControl', name: 'ExperimentControl' },
  { value: 'RobotHealthNotification', name: 'RobotHealthNotification' },
  { value: 'ImageReview', name: 'Image Review' },
  { value: 'ContextualMessage', name: 'Contextual Message' },
  { value: 'Banner', name: 'Banner' },
  { value: 'ContextualMessageNonDismissible', name: 'ContextualMessageNonDismissible' },
  { value: 'MapDirty', name: 'Map Dirty' }
] as const;

export const CAMPAIGN_CHANNELS = [
  { value: 'message_center', name: 'Message Center' },
  { value: 'Circuit', name: 'Circuit' },
  { value: 'robot_health', name: 'Robot Health' }
] as const;

export const CAMPAIGN_CATEGORIES = [
  { value: 'coach', name: 'Coach' },
  { value: 'ecommerce', name: 'ECommerce' },
  { value: 'smart_home', name: 'SmartHome' },
  { value: 'smart_map', name: 'SmartMap' },
  { value: 'robot_release', name: 'RobotRelease' }
] as const;

export const CAMPAIGN_SUBCATEGORIES = [
  { value: 'introduce', name: 'Introduce' },
  { value: 'announce', name: 'Announce' },
  { value: 'educate', name: 'Educate' },
  { value: 'recommend', name: 'Recommend' },
  { value: 'promote', name: 'Promote' },
  { value: 'maintain', name: 'Maintain' },
  { value: 'survey', name: 'Survey' }
] as const;

export const CAMPAIGN_APP_TYPES = [
  { value: 'prime', name: 'Prime' },
  { value: 'legacy', name: 'Legacy' }
] as const;

export const PART_HEALTH_COUNT_TYPES = [
  { value: 'minutes', name: 'Minutes' },
  { value: 'mission', name: 'Mission' },
  { value: 'combo_missions', name: 'Combo Missions' },
  { value: 'evacs', name: 'Evacs' },
  { value: 'battery', name: 'Battery' },
  { value: 'pad_washes_used', name: 'Pad Washes Used' },
  { value: 'sqft', name: 'Square Feet Cleaned' }
] as const;

export const CLEANING_PARAMETERS = [
  { value: 'operatingMode', name: 'Cleaning Mode' },
  { value: 'suctionLevel', name: 'Suction' },
  { value: 'swScrub', name: 'Smart Scrub' },
  { value: 'gentleMode', name: 'Careful Drive' },
  { value: 'carpetBoost', name: 'Suction' },
  { value: 'vacHigh', name: 'Suction' },
  { value: 'suction', name: 'Suction' },
  { value: 'twoPass', name: 'Cleaning Passes' },
  { value: 'noAutoPasses', name: 'noAutoPasses' },
  { value: 'cleaningPasses', name: 'Cleaning Passes' },
  { value: 'padWetness', name: 'Liquid amount' },
  { value: 'reusable', name: 'Pad plate (Reusable)' },
  { value: 'disposable', name: 'Pad plate (Disposable)' },
  { value: 'padPlate', name: 'Pad plate' }
] as const;

export const SUCTION_LEVEL_LABELS = {
  1: 'Quiet',
  2: 'Low',
  3: 'Standard',
  4: 'High'
};

export const COMBINED_SUCTION_LABELS = {
  'false,false': 'Low',
  'true,false': 'Medium',
  'false,true': 'High',
  'true,true': 'High'
};

export const CLEANING_MODE_LABELS = {
  2: 'Vacuum',
  4: 'Mop',
  6: 'Vac + Mop',
  32: 'Combo bin cleaning (Lapis vac+mop)',
  512: 'Vac-then-mop'
};

export const ENABLED_DISABLED_LABELS = {
  0: 'Disabled',
  1: 'Enabled'
};

export const PAD_PLATE_LEVEL_LABELS = {
  1: 'Eco',
  2: 'Standard',
  3: 'Ultra'
};
